export default __webpack_public_path__ + "static/skrap-3a1e6e224b218b547798913a4cc79f32.png";